import React from "react";

function PrivacyPolicy() {
  return (
    <div class="max-w-screen-lg mx-auto py-8 px-4">
      <h1 class="text-3xl font-bold text-center text-gray-900 mb-6">
        Privacy Policy
      </h1>

      <p class="text-gray-700 mb-4">
        At Mobi POS, we are committed to protecting your privacy. This Privacy
        Policy explains how we handle your information and outlines our
        practices regarding data collection. Please note that we do not collect
        or store any personal information from users of this website.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        1. No Collection of Personal Data
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS does not collect, store, or process any personal information
        from users. You can browse our website and view device specifications
        without the need to provide any personal details such as names, email
        addresses, or payment information.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        2. Cookies and Tracking Technologies
      </h2>
      <p class="text-gray-700 mb-4">
        We do not use cookies, tracking technologies, or any form of local
        storage to collect information about your browsing behavior. No tracking
        mechanisms are implemented to monitor your activity on this site.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        3. Third-Party Links
      </h2>
      <p class="text-gray-700 mb-4">
        Our website may contain links to third-party websites for your
        convenience. Please note that Mobi POS is not responsible for the
        privacy practices or content of these external sites. We recommend
        reviewing the privacy policies of any external sites you visit.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        4. Use of Information
      </h2>
      <p class="text-gray-700 mb-4">
        All the information on Mobi POS is provided for informational purposes
        only. The specifications and details of POS devices are offered to help
        users explore and understand the products. However, no personal data is
        required or requested from users at any point.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">5. Data Security</h2>
      <p class="text-gray-700 mb-4">
        Since we do not collect or store personal information, Mobi POS does not
        implement data security protocols to safeguard user data. There is no
        personal or sensitive data stored on our servers.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        6. Children's Privacy
      </h2>
      <p class="text-gray-700 mb-4">
        Our website is not directed toward children under the age of 13. As we
        do not collect personal data, there is no risk of any personal
        information being collected from children.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        7. Changes to This Privacy Policy
      </h2>
      <p class="text-gray-700 mb-4">
        Mobi POS reserves the right to modify or update this Privacy Policy at
        any time. Any changes will be reflected on this page with an updated
        revision date. By continuing to use the website after any changes, you
        agree to be bound by the updated policy.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-3">
        8. Contact Information
      </h2>
      <p className="mb-4 ml-5">
        If you have any questions about this Privacy Policy, You can contact us:
      </p>
      <div className="ml-5">
        <div className="ml-5">
          <p>
            <b>By sending us an email : </b>{" "}
            <a
              href="mailto:mobipos@spidertechnosoft.com"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              mobipos@spidertechnosoft.com
            </a>
          </p>
          <p>
            <b>Contact Number : </b>{" "}
            <a
              href="tel:+917736904688"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              +91 77369 04688
            </a>{" "}
            /{" "}
            <a
              href="tel:+919995801797"
              className="text-blue-600 hover:underline hover:text-blue-700"
            >
              +91 99958 01797
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
